import { useCallback as A, useEffect as u } from "react";
import { c as O, f as l } from "../../create-component-CBAeEoQ6.js";
import { useToastStateAtoms as S } from "./ToastState/index.js";
import { u as v } from "../../use-unique-id-BA9hSqap.js";
import { a as f } from "../../react-B_GApDuV.js";
const j = O(
  "Toast",
  l(
    ({ autoDismiss: s = !0, autoDismissTimeout: c = 6e3, onClose: o, ...e }, m) => {
      const i = JSON.stringify(Object.values(e)), t = v("toast"), { addOrUpdateToastAtom: d, removeToastAtom: T } = S(), n = f(d), a = f(T), p = A(() => {
        o == null || o(), a(t);
      }, [o, t, a]);
      return u(() => {
        const r = e.icon || e.iconStart;
        n(t, {
          ...e,
          icon: r,
          ref: m,
          onClose: p
        });
      }, [t, i, n, m]), u(() => {
        const r = setTimeout(() => {
          s && a(t);
        }, c);
        return () => clearTimeout(r);
      }, [t, s, c, a]), null;
    }
  )
);
export {
  j as Toast
};
//# sourceMappingURL=index.js.map
